export default "__VITE_ASSET__DgiKcVrM__"